/**
 * Utilities for running inside an <iframe> on the parent (WordPress) page.
 * We post the document height so the parent can auto-resize, and emit a
 * completion event when the user finishes the screener.
 */

function postToParent(message: Record<string, unknown>): void {
  if (window.parent && window.parent !== window) {
    window.parent.postMessage(message, "*");
  }
}

let observer: ResizeObserver | null = null;

/** Start reporting document height changes to the parent frame. */
export function startAutoResize(): void {
  if (observer) return;
  // Fixed desktop card sizing is disabled while embedded (see styles.css).
  if (window.parent && window.parent !== window) {
    document.documentElement.classList.add("embedded");
  }
  const send = () => {
    const height = Math.ceil(
      document.documentElement.scrollHeight || document.body.scrollHeight,
    );
    postToParent({ type: "screener:resize", height });
  };
  observer = new ResizeObserver(send);
  observer.observe(document.body);
  window.addEventListener("load", send);
  send();
}

export function emitStep(step: string): void {
  postToParent({ type: "screener:step", step });
}

export function emitCompleted(payload: {
  category: string;
  srtDb?: number;
}): void {
  postToParent({ type: "screener:completed", ...payload });
}
